// imports
import {
  clearState as clearStateAction,
  setCrewTraitMatching as setCrewTraitMatchingAction
} from './slices/lib/user';
import {
  setBioPrompt as setBioPromptAction,
  setMapRegion as setMapRegionAction,
  resetRewardPrompt as resetRewardPromptAction,
  setNotificationPrompt as setNotificationPromptAction
} from './slices/lib/ui';

// exports
export const clearState = clearStateAction;
export const setCrewTraitMatching = setCrewTraitMatchingAction;

export const setBioPrompt = setBioPromptAction;
export const setMapRegion = setMapRegionAction;
export const resetRewardPrompt = resetRewardPromptAction;
export const setNotificationPrompt = setNotificationPromptAction;
